import { fetchAuthSession } from 'aws-amplify/auth';
import {
    BedrockAgentCoreClient,
    InvokeHarnessCommand          // ✅ InvokeHarnessCommand, not InvokeAgentRuntimeCommand
} from "@aws-sdk/client-bedrock-agentcore";

// Session ID must be 33–100 characters
const ensureSessionIdLength = (id) => {
    if (id.length >= 33) return id;
    return id.padEnd(33, '0');
};

const SendPrompt = async (sessionId, text) => {
    const session = await fetchAuthSession();

    const bedrockClient = new BedrockAgentCoreClient({
        region: 'us-east-1',
        credentials: session.credentials
    });

    const currentDate = new Date().toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });

    const fullPrompt = `The current date is Date: ${currentDate} and the users request is Prompt: ${text}. Remember to put your response in the proper format where {response: "your response to the user", apiSeason: "", apiWeek, slateIDs: ["slateID"], players: ["name"]} and only return the json, no other text.`;

    const params = {
        harnessArn: process.env.REACT_APP_HARNESS_ARN,            // ✅ harnessArn, not agentRuntimeArn
        runtimeSessionId: ensureSessionIdLength(sessionId),        // 33–100 chars
        messages: [                                                 // ✅ Converse-shaped messages, not raw payload
            {
                role: "user",
                content: [{ text: fullPrompt }]
            }
        ]
    };

    try {
        const command = new InvokeHarnessCommand(params);
        const response = await bedrockClient.send(command);

        // ✅ Stream processing, not transformToString()
        let completion = "";
        if (response.stream) {
            for await (const event of response.stream) {
                if (event.contentBlockDelta?.delta?.text) {
                    completion += event.contentBlockDelta.delta.text;
                }
            }
        }

        return completion;
    } catch (error) {
        console.error('Error calling Bedrock AgentCore Harness:', error);
        throw error;
    }
};

export default SendPrompt;
